export default "__VITE_ASSET__BI9xOalE__"